var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiCreateClientHotlineAdviceContact } from '@/actions/ClientHotlineActions';
/**
 * コンサルホットライン（企業側）でコンサル選定アドバイザー相談を送信するカスタムフック
 */
export const useHotlineClientDetailAdvisor = (options) => {
    const { dispatch, id, onSuccess } = options;
    const onSubmitAdviserModal = useCallback((formValue) => __awaiter(void 0, void 0, void 0, function* () {
        // コンサル選定アドバイザー相談を送信
        dispatch(apiCreateClientHotlineAdviceContact({
            json: formValue,
            path: {
                id,
            },
        }, {}));
        // 送信後の処理
        yield (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
    }), [dispatch, id, onSuccess]);
    return {
        onSubmitAdviserModal,
    };
};
